var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$auth.loggedIn)?_c('v-avatar',{staticClass:"border--bronze",attrs:{"size":_vm.size}},[_c('img',{attrs:{"src":_vm.user.avtarName,"alt":"profile picture"}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }